/**
 * Client-side fast-fail for Bestandsupload (PLAN-FASE3.md WP-07) — mirrors
 * `php/api_uploads.php`'s own limits so an obviously-bad file never makes a
 * round trip, but is not the real gate: the server re-checks size and the
 * actual file bytes (not just the extension) regardless of what this says.
 */
export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024; // 10 MB

export const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'gif'];
export const DOCUMENT_EXTENSIONS = [...IMAGE_EXTENSIONS, 'pdf', 'doc', 'docx', 'xlsx'];

export function fileValidationError(
  file: File,
  allowedExtensions: string[],
  maxBytes: number = MAX_UPLOAD_BYTES,
): string | null {
  if (file.size > maxBytes) {
    return 'tooLarge';
  }
  const extension = file.name.split('.').pop()?.toLowerCase();
  if (!extension || !allowedExtensions.includes(extension)) {
    return 'invalidType';
  }
  return null;
}
